module.exports = __webpack_public_path__ + "img/right_img1.a5ff79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/right_img1.png
// module id = lEex
// module chunks = 0